//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/VisualReporting.js";
import "../no/Object.js";
import "../VisualReporting/VisualReporting.VisualReportManager.js";
let d=[[[0,"ExploreReport",1,0]],[[["nxObjects","reportOnObjectsOption"],"ReportOnObjects",{},2,0],[["nxObjects"],"RemoveReportObjects",{},1,0],[[],"ClearReportObjects",{},0,0],[[],"ResetReportObjects",{},0,0],[[],"GetExploringGroup",{R_:{groupLabel:"VisualReporting.GroupLabel"}},0,0],[["groupLabel"],"SetGroupToExplore",{},1,0],[["reportOnObjectsOption"],"ReportDown",{R_:{reportDownStatus:''}},1,0],[["nxObjects","reportOnObjectsOption"],"ReportDown1",{R_:{reportDownStatus:''}},2,0],[["nxObjects","reportOnObjectsOption"],"ReportOnChildren",{},2,0],[["nxObjects","reportOnObjectsOption"],"ReportOnParents",{},2,0]],[]];
SPLM.VisualReporting.VisualReportExplorer = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.VisualReporting.VisualReportExplorer";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.VisualReporting.VisualReportExplorer.ExploreReportOption = Object.freeze({
    "Off" : "Off", "On" : "On"});

SPLM.VisualReporting.VisualReportExplorer.ReportOnObjectsOption = Object.freeze({
    "Replace" : "Replace", "Add" : "Add"});

SPLM.VisualReporting.VisualReportExplorer.ReportDownStatus = Object.freeze({
    "None" : "None", "End" : "End", "More" : "More"});

export default SPLM;